import { createAction } from 'redux-actions';
import { ProfileSkin } from '../../types/profileSkins';

export const setActiveSkin = createAction(
  'PROFILE_SKINS.SET_ACTIVE',
  (skin: ProfileSkin) => ({ skin })
);

export const saveActiveSkin = createAction(
  'PROFILE_SKINS.SAVE_ACTIVE',
  () => ({})
);

export const toggleSkinSelector = createAction(
  'PROFILE_SKINS.TOGGLE_SELECTOR',
  () => ({})
);

export const finishSaving = createAction(
  'PROFILE_SKINS.FINISH_SAVING',
  () => ({})
);
